import { ScriptNode } from '@/config/scripts/prudential-annual-checkin';
import { ScriptState } from '@/utils/scriptEngine';
import { CallMode, CallType } from '@/routes/agent/RolePlay';

export enum CallState {
  INCOMING = 'incoming',
  ACTIVE = 'active',
  ENDED = 'ended',
}

export enum LoadingState {
  INITIAL = 'initial',
  CONNECTING = 'connecting',
  LOADING_PRODUCT = 'loading_product',
  READY = 'ready',
  ACTIVE = 'active',
  ENDING = 'ending',
  ERROR = 'error',
}

export enum AccentType {
  DEFAULT = 'default',
  BRITISH = 'british',
  IRISH = 'irish',
}

export interface Transcript {
  source: string;
  message: string;
  timestamp: Date;
}

export interface BaseAgentCallProps {
  productCode: string;
  callType: CallType;
  accent?: AccentType;
  mode?: CallMode;
  scriptId?: string;
  parentId?: string | null;
  userId?: string;
  onClientInfoNeeded?: () => void;
}

export interface AgentCallInterface {
  // State
  loadingState: LoadingState;
  error: string | null;
  callState: CallState;
  sessionId: string | null;
  agentInfo: any;
  clientInfo: any;
  product: any;
  isMuted: boolean;
  callDuration: number;
  transcript: Transcript[];
  isSpeaking: boolean;
  accent: AccentType;
  currentScriptNode: ScriptNode | null;
  scriptState?: ScriptState | null;

  // Methods
  handleAnswerCall: () => Promise<void>;
  handleEndCall: () => Promise<void>;
  setClientInfo: (info: any) => void;
  saveClientInfo: (
    clientInfoData: any,
    followupDate?: string,
    followupTime?: string,
    followupNotes?: string,
  ) => Promise<string>;
  formatTime: (seconds: number) => string;
  retryInitialization: () => Promise<void>;
}

export enum AgentProvider {
  ELEVENLABS = 'elevenlabs',
  LIVEKIT = 'livekit',
}
